/* unplugin-vue-components disabled */import { render } from "./GetStartedBlock.vue?vue&type=template&id=a012d81e&scoped=true&ts=true"
import script from "./GetStartedBlock.vue?vue&type=script&lang=ts"
export * from "./GetStartedBlock.vue?vue&type=script&lang=ts"

import "./GetStartedBlock.vue?vue&type=style&index=0&id=a012d81e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a012d81e"]])

export default __exports__